// extracted by mini-css-extract-plugin
export default {"text":"WorkingHoursNotice_text__uIhop"};